import { render, staticRenderFns } from "./DocumentsPage.vue?vue&type=template&id=30e105e5&"
import script from "./DocumentsPage.vue?vue&type=script&lang=js&"
export * from "./DocumentsPage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsPage.vue?vue&type=style&index=0&id=30e105e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports